import styled from "styled-components";

const Error = styled.span`
    display: block;
    margin-top: 5px;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 1.4rem;
    font-weight: 300;
    line-height: 1.8rem;
    color: #b42c2c;
`;

export default Error;
